/* eslint-disable camelcase */
import { hospitalityRoles, hospitalityTypes, industryRoles, industryTypes } from '../consts';

type TErrorMessage = {
    response: {
        data: {
            meta: {
                detail: {
                    non_field_errors: string[];
                    date: string[];
                    agency: string[];
                    duration: {
                        duration: string;
                    };
                    breaks: string[];
                    consultant_splits: string[] | {agent?: string[], split_value?: string[]}[];
                    title: string[];
                };
            };
        };
    };
};

export function replaceRoleShortcutWithFullRoleName(text: string) {
    let replacedText = text;

    const hospitalityTypesList = Object.entries(hospitalityTypes);

    hospitalityTypesList.forEach(type => {
        replacedText = replacedText.replace(
            ` ${type[1].toLowerCase()} `,
            ` ${hospitalityRoles[type[0] as keyof typeof hospitalityRoles]} `,
        );
    });

    const industryTypesList = Object.entries(industryTypes);

    industryTypesList.forEach(type => {
        replacedText = replacedText.replace(
            ` ${type[1].toLowerCase()} `,
            ` ${industryRoles[type[0] as keyof typeof industryRoles]} `,
        );
    });

    return replacedText;
}

const getUniqueErrors = (array: any[]) => array.filter(
    (item, index) => array.indexOf(item) === index,
);


export function getErrorMessages(error: TErrorMessage): string {
    if (!error.response || !error.response.data) {
        return 'Network error, please check your connection';
    }

    const errorDetail = error?.response?.data?.meta?.detail;

    if (typeof errorDetail === 'string') {
        return errorDetail;
    }

    if (errorDetail?.non_field_errors) {
        return getUniqueErrors(errorDetail.non_field_errors).join(', ');
    }

    if (errorDetail?.breaks) {
        return getUniqueErrors(errorDetail.breaks).join(', ').replace(
            'this',
            'Break'
        );
    }

    if (errorDetail?.consultant_splits) {
        const firstError = errorDetail.consultant_splits[0];
        if (typeof firstError === 'string') {
            return firstError;
        }
        return Object.values(firstError)[0].join(', ');
    }

    if (errorDetail?.duration) {
        if (Array.isArray(errorDetail?.duration)) {
            return Object.values(errorDetail.duration)[0]?.duration;
        }
        return errorDetail.duration?.duration;
    }

    if (errorDetail?.title) {
        if (Array.isArray(errorDetail?.title)) {
            return Object.values(errorDetail.title)[0].replace(
                'this',
                'Job Title',
            );
        }
    }

    if (errorDetail) {
        const firstValueErrorDetail = Object.values(errorDetail)[0];

        if (Array.isArray(firstValueErrorDetail)) {
            const errors = getUniqueErrors(firstValueErrorDetail);
            return errors.map((err, i) =>
                typeof err === 'string' ? err : JSON.stringify(errors[i])
            ).join(', ');
        }
    }

    return 'Unknown error has occurred.';
}
